import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MapPinIcon, MessageCircleIcon } from 'lucide-react';
import { LinkButton } from './ui/Button';
import { Pill } from './ui/Pill';
import { waLink } from '../utils/whatsapp';
const treatmentLinks = ['Valoración inicial', 'Limpieza dental', 'Ortodoncia', 'Estética dental', 'Implantes', 'Urgencias'];
const clinicLinks = [{
  label: 'Nuestro enfoque',
  href: '#enfoque'
}, {
  label: 'Equipo',
  href: '#equipo'
}, {
  label: 'Reseñas',
  href: '#resenas'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}];
function ColumnTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="font-sans text-[13px] font-semibold uppercase tracking-[0.12em] text-white/40" data-id="element-56" data-mp="3qdf4t82yp2b6">{children}</h3>;
}
export function Footer() {
  return <footer className="bg-deep" data-id="element-57" data-mp="29xlzel58oyhi">
      <div className="mx-auto max-w-shell px-5 py-12 lg:px-[120px] lg:py-16" data-id="element-58" data-mp="2a1jk3b7gty3i">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-59" data-mp="2ezl4q0kji5h3">
          <div data-id="element-60" data-mp="3labt60db0esh">
            <p className="font-display text-[22px] font-bold text-white" data-id="element-61" data-mp="3l9sin4pzgsoh">Sonrisa Clara</p>
            <p className="mt-3 font-sans text-[14px] text-white/60" data-id="element-62" data-mp="3gc0ixoj3k29q">Odontología moderna para toda la familia</p>
            <p className="mt-3 max-w-[220px] font-sans text-[13px] leading-[1.6] text-white/50" data-id="element-63" data-mp="3v5n5kc18p9x2">
              Atención odontológica profesional, moderna y cercana para toda tu familia.
            </p>
          </div>

          <div data-id="element-64" data-mp="33xd9vvh5urg">
            <ColumnTitle data-id="element-65" data-mp="3477xwrgsq3h">Tratamientos</ColumnTitle>
            <ul className="mt-4 flex flex-col gap-[10px]" data-id="element-66" data-mp="33nlq3us7fjn">
              {treatmentLinks.map(label => <li key={label} data-id="element-67" data-mp="huwiqy10k36t">
                  <a href="#tratamientos" className="font-sans text-[14px] text-white/70 transition-colors hover:text-secondary" data-id="element-68" data-mp="cu0h6r44wt4k">
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-69" data-mp="tvmqpiubmimf">
            <ColumnTitle data-id="element-70" data-mp="tw5y45mchom7">Consultorio</ColumnTitle>
            <ul className="mt-4 flex flex-col gap-[10px]" data-id="element-71" data-mp="tt9ymcuumrvn">
              {clinicLinks.map(link => <li key={link.label} data-id="element-72" data-mp="yrv3wqoyk1qy">
                  <a href={link.href} className="font-sans text-[14px] text-white/70 transition-colors hover:text-secondary" data-id="element-73" data-mp="13t0y6sy9nx2l">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-74" data-mp="1hjnw4iw7dixm">
            <ColumnTitle data-id="element-75" data-mp="1hj4c8wmzskgy">Contacto</ColumnTitle>
            <ul className="mt-4 flex flex-col gap-3" data-id="element-76" data-mp="1mk1s32kj52fa">
              <li id="footer-ubicacion" className="flex items-center gap-2 font-sans text-[14px] text-white/70" data-id="element-77" data-mp="1mkbmr3girxrb">
                <MapPinIcon className="h-4 w-4 shrink-0 text-secondary" strokeWidth={1.6} data-id="element-78" data-mp="1rgshigi85add" />
                Bogotá, Colombia
              </li>
              <li className="flex items-center gap-2 font-sans text-[14px] text-white/70" data-id="element-79" data-mp="3t9q805oj3qv5">
                <ClockIcon className="h-4 w-4 shrink-0 text-secondary" strokeWidth={1.6} data-id="element-80" data-mp="2afnab5srhpx4" />
                Lunes a Viernes · 8:00 am – 6:00 pm
              </li>
              <li className="flex items-center gap-2 font-sans text-[14px] text-white/70" data-id="element-81" data-mp="25mamgxvwpn5f">
                <MessageCircleIcon className="h-4 w-4 shrink-0 text-secondary" strokeWidth={1.6} data-id="element-82" data-mp="21n1t3u4s3rae" />
                WhatsApp directo
              </li>
            </ul>
            <LinkButton variant="whatsapp" size="sm" href={waLink('Hola, quisiera contactarme con Sonrisa Clara.')} target="_blank" rel="noreferrer" className="mt-4" data-id="element-83" data-mp="2tcy80lyqwbag">
              Escribir ahora
              <ArrowRightIcon className="h-3 w-3" data-id="element-84" data-mp="2fezzhx73v92v" />
            </LinkButton>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 bg-deeper" data-id="element-85" data-mp="18yxl31yqj24j">
        <div className="mx-auto grid max-w-shell gap-8 px-5 py-8 lg:grid-cols-[1fr_auto] lg:items-center lg:px-[120px]" data-id="element-86" data-mp="13zb88tmtjnw9">
          <div data-id="element-87" data-mp="2rvhjbwxt0rca">
            <Pill tone="demo" className="text-[12px]" data-id="element-88" data-mp="2ruxzgaolfsvm">
              Página demostrativa
            </Pill>
            <p className="mt-2 max-w-[520px] font-sans text-[12px] leading-[1.6] text-white/40" data-id="element-89" data-mp="2wo0t0itdf2bt">
              Esta página fue diseñada por ORIGEN como demostración del sistema web para consultorios odontológicos. No
              corresponde a un consultorio real.
            </p>
            <p className="mt-2 font-sans text-[12px] text-white/30" data-id="element-90" data-mp="3bkrt6uavci2h">
              Política de privacidad · Tratamiento de datos ·{' '}
              <Link to="/design-system" className="underline transition-colors hover:text-secondary" data-id="element-91" data-mp="3fj7nzkd6yuqg">
                Design system
              </Link>
            </p>
          </div>

          <div className="rounded-xl border border-secondary/25 bg-secondary/10 px-6 py-5 lg:max-w-[320px]" data-id="element-92" data-mp="36isrrpyovv86">
            <p className="font-sans text-[15px] font-semibold text-white" data-id="element-93" data-mp="1q8gohn0l583v">¿Eres odontólogo/a?</p>
            <p className="mt-1 font-sans text-[13px] leading-[1.6] text-white/60" data-id="element-94" data-mp="1v3dusm6hd3d2">
              Podemos diseñar una presencia digital así para tu consultorio.
            </p>
            <LinkButton variant="secondary" size="sm" href={waLink('Hola, soy odontólogo/a y vi la página demo de Sonrisa Clara. Me interesa algo así para mi consultorio.')} target="_blank" rel="noreferrer" className="mt-3 font-semibold" data-id="element-95" data-mp="1im368j3o5pht">
              Quiero verlo para mi consultorio
              <ArrowRightIcon className="h-3 w-3" data-id="element-96" data-mp="zy7vl83csrsx" />
            </LinkButton>
            <p className="mt-2 font-sans text-[11px] italic text-white/35" data-id="element-97" data-mp="1dojr7gz5d8ot">
              Este botón conecta con ORIGEN, no con el consultorio
            </p>
          </div>
        </div>
      </div>
    </footer>;
}